import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * The back link every page starts with, with a breadcrumb above it for its section and itself. `crumbs`: from
 * navigation/modules.js `crumbsFor(moduleKey)` (Home, section, page), or a literal trail for a page that is not
 * a registry card (a detail page: a single report, a settlement, a PDF tool). The breadcrumb never repeats
 * "Home" — the top bar already has a permanent link there — so it only shows once there is a section to name.
 * The last crumb is the page itself (no `to`); `backTo`/`backLabel` default to the crumb before it, or Home.
 */
const PageHeader = ({ crumbs, backTo, backLabel }) => {
    const navigate = useNavigate();
    const trail = crumbs && crumbs.length ? crumbs : [{ label: 'Home', to: '/dashboard' }];
    const parent = trail.length > 1 ? trail[trail.length - 2] : trail[0];
    const to = backTo || parent.to || '/dashboard';
    const label = backLabel || (trail.length > 1 ? `Back to ${parent.label}` : 'Back to Home');
    const shown = trail.slice(1); // everything after Home

    return (
        <div style={{ marginBottom: '1rem' }}>
            {shown.length > 1 && (
                <nav aria-label="Breadcrumb" style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                    {shown.map((c, i) => (
                        <span key={i}>
                            {i > 0 && <span aria-hidden="true"> › </span>}
                            {c.to ? <Link to={c.to} style={{ color: 'var(--text-muted)' }}>{c.label}</Link> : c.label}
                        </span>
                    ))}
                </nav>
            )}
            <button
                onClick={() => navigate(to)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, padding: 0, color: 'var(--text-muted)' }}
            >
                <ArrowLeft size={16} /> {label}
            </button>
        </div>
    );
};

export default PageHeader;
